<template>
  <md-card class="card-content">
    <md-card-header class="md-card-header-text md-card-header-green">
      <div class="card-text">
        <h4 class="title text-lg">
          {{ $t("common.overview") }}
        </h4>
      </div>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <div class="w-full">
          <filter-bar
            @fetch-report="fetchReport"
            :defaultTerms="filteringOptions.defaultTerms"
            :defaultClasses="filteringOptions.defaultClasses"
          ></filter-bar>
        </div>

        <div
          v-if="!!presentSummary"
          class="results-area md-layout-item md-size-100 mt-6"
        >
          <result-box
            iconHTML="<i class='fas fa-user-graduate'></i>"
            :resultTxt="presentSummary.total_students"
            :title="$t('dashboard.synthetic.total_students')"
            :class="['result-box-color']"
          ></result-box>
          <result-box
            iconHTML="<i class='fas fa-school'></i>"
            :resultTxt="presentSummary.total_classes"
            :title="$t('dashboard.synthetic.total_classes')"
            :class="['result-box-color']"
          ></result-box>
          <result-box
            v-if="!isNaN(presentSummary.attend_percentage + '')"
            iconHTML="<i class='far fa-calendar-check'></i>"
            :resultTxt="
              `${Number(presentSummary.attend_percentage).toFixed(2)}%`
            "
            :title="$t('attendance_report.attendance_percentage')"
            :class="['result-box-color']"
          ></result-box>
          <result-box
            v-if="!isNaN(presentSummary.absence_percentage + '')"
            iconHTML="<i class='far fa-calendar-times'></i>"
            :resultTxt="
              `${Number(presentSummary.absence_percentage).toFixed(2)}%`
            "
            :title="$t('attendance_report.absence_percentage')"
            :class="['result-box-color']"
          ></result-box>
        </div>

        <!-- Attendance chart -->
        <div
          v-if="!!attendanceData"
          class="md-layout-item md-size-40 md-small-size-100 mt-8"
        >
          <information-area
            :title="
              $t('attendance_report.overview.area_graph_attendance_title')
            "
          >
            <template #content>
              <p class="font-medium mb-2">
                {{
                  $t("attendance_report.overview.area_graph_attendance_desc")
                }}
              </p>
              <attendance-chart
                :attendance-data="attendanceData"
                class="mt-8"
              ></attendance-chart>
            </template>
          </information-area>
        </div>
        <!-- Attendance chart -->

        <!-- Term attendance chart -->
        <div
          v-if="!!presentPercentage"
          class="md-layout-item md-size-60 md-small-size-100 mt-12"
        >
          <p class="font-medium mb-2">
            {{
              $t("attendance_report.overview.area_graph_term_attendance_desc")
            }}
          </p>
          <period-attendances
            :present-percentage="presentPercentage"
          ></period-attendances>
        </div>
        <!--  Term attendance chart -->
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import { InformationArea, ResultBox } from "@/pages/Report/Components";
import {
  AttendanceChart,
  PeriodAttendances
} from "@/pages/Report/Attendance/Components";
import { service_paths } from "@/constants/Services";
import { initLoader } from "@/helpers/utils";
import FilterBar from "./FilterBar.vue";

export default {
  components: {
    InformationArea,
    ResultBox,
    AttendanceChart,
    PeriodAttendances,
    FilterBar
  },
  inject: ["filteringOptions"],
  data: () => ({
    path: service_paths.reports,
    reportData: {
      presentSummary: {
        total_students: null,
        total_classes: null,
        attend_percentage: null,
        absence_percentage: null
      },
      attendanceData: null,
      presentPercentage: null
    }
  }),
  computed: {
    presentSummary() {
      if (
        Object.values(this.reportData.presentSummary).every(value => !value)
      ) {
        return null;
      }

      return this.reportData.presentSummary;
    },
    attendanceData() {
      return this.reportData.attendanceData;
    },
    presentPercentage() {
      return this.reportData.presentPercentage;
    }
  },
  methods: {
    fetchReport(reportParams) {
      const loader = initLoader();

      Promise.all([
        this.fetchPresentSummary(reportParams),
        this.fetchAttendancePercent(reportParams),
        this.fetchPersentPercentage(reportParams)
      ]).finally(() => loader.hide());
    },
    fetchPresentSummary(reportParams) {
      return this.$axios
        .get(
          `${service_paths.reports}/attendance/present-summary`,
          reportParams,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.reportData.presentSummary = data;
        });
    },
    fetchAttendancePercent(reportParams) {
      return this.$axios
        .get(
          `${service_paths.reports}/attendance/overview-percentage`,
          reportParams,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.reportData.attendanceData = data;
        });
    },
    fetchPersentPercentage(reportParams) {
      return this.$axios
        .get(
          `${service_paths.reports}/attendance/present-percentage`,
          reportParams,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.reportData.presentPercentage = data;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.results-area {
  display: flex;
  justify-content: center;
  align-content: center;

  & > * + * {
    @apply ml-10;
  }

  .result-box-color {
    color: #5d5fef;
    padding-bottom: 1.5rem;
    aspect-ratio: unset;
    font-size: 1.2rem;
    width: 200px;
  }
}
</style>
